<template>
  <div @scroll="disableAutoScroll">
    <widget-library class="absolute top-0 z-10" />
    <vs-row v-if="configDashboard" class="flex mb-3 lg:mb-6 justify-between items-center">
      <vs-col class="flex" vs-lg="7" vs-sm="4" vs-xs="12">
        <h3 class="mb-3 md:mb-0 text-xl md:text-2xl font-medium">
          Configure Dashboard
        </h3>
      </vs-col>
    </vs-row>
    <div class="vx-row user-info-sm relative">
      <vs-col class="vx-col w-full lg:w-2/3 w--70 relative">
        <vs-row class="rounded-lg overflow-hidden">
          <vs-col v-if="isTalentCard" class="mb-base relative">
            <vs-card v-if="configDashboard" class="absolute charter-container">
              <vs-row class="flex items-center justify-between z-10 px-6 pt-6">
                <h3 class="mb-1" style="color: #30384b">Talent Card</h3>
                <vs-chip transparent color="#FBA727" class="text-base text-center cursor-pointer z-10"
                  @click.native="removeTalentCard">
                  Remove
                </vs-chip>
              </vs-row>
            </vs-card>

            <!-- NEW: SKELETON LOADER -->
            <div v-if="isSkeletonVisible" class="skeleton-card" style="height: 600px; border-radius: .5rem;"></div>

            <!-- ACTUAL TALENT CARD -->
            <vs-card v-else class="talent-card-wrapper" :class="configDashboard ? 'opacity m-0 rounded charter-container' : ''">
              <vs-row class="justify-between items-center" :class="configDashboard ? '' : 'mb-4'">
                <h3 v-if="!configDashboard" class="p-4 pb-0" style="color: #30384b">
                  {{ $t('orgDashboard.userDashboard.talentCard') }}
                </h3>
                
                <div class="p-4 pb-0 flex items-center justify-end gap-2">
                  <div class="cursor-pointer">
                    <vx-tooltip text="Download Resume" position="bottom">
                      <div class="action-btn-circle" @click.stop="downloadResume()">
                        <feather-icon icon="DownloadIcon" svgClasses="w-5 h-5 cursor-pointer stroke-current action-icon" />
                      </div>
                    </vx-tooltip>
                  </div>
                  <div class="cursor-pointer">
                    <vx-tooltip text="Edit" position="bottom">
                       <div class="action-btn-circle" @click.stop="editCard()">
                          <feather-icon icon="EditIcon" svgClasses="w-5 h-5 cursor-pointer stroke-current action-icon" />
                       </div>
                    </vx-tooltip>
                  </div>
                </div>
              </vs-row>
              
              <div id="talent-card-pdf-content">
                <talent-card />
              </div>
            </vs-card> 
          </vs-col></vs-row>

        <vs-row>
          <!-- development charter  -->
          <vs-col v-if="isDevelopmentCharter" class="mb-base relative">
            <vs-card v-if="configDashboard" class="absolute m-0">
              <div class="flex items-center justify-between z-10 p-4 pt-6">
                <h4 class="mb-1" style="color: #30384b">Development Charter</h4>
                <vs-chip transparent color="#FBA727" class="text-base text-center cursor-pointer z-10"
                  @click.native="removeDevelopmentCharter">
                  Remove
                </vs-chip>
              </div>
            </vs-card>

            <div :class="configDashboard ? 'opacity pointer-events-none' : ''">
              <div class="flex justify-between flex-wrap mb-5" style="align-items: center">
                <div v-show="!configDashboard" class="text-lg md:text-2xl mb-2 md:mb-0">
                  {{ $t('orgDashboard.userDashboard.developmentCharter') }}
                </div>
                <div class="relative">
                  <!-- sort dropdown  -->
                  <vs-select class="rounded-3xl" placeholder="Sort By" v-model="recommendationsType">
                    <vs-select-item v-for="(type, index) in types" :key="index" :value="type.value" :text="type.text" />
                  </vs-select>
                  <div v-if="!blinkers.readFeedDropDownTip" class="absolute flex h-4 w-4 blinker z-40 cursor-pointer"
                    @click="showBlinkerTip" ref="wrapper">
                    <span
                      class="animate-ping absolute inline-flex h-full w-full rounded-full opacity-50 blinker-color"></span>
                    <span class="relative inline-flex rounded-full h-full w-full blinker-color"></span>
                  </div>

                  <div class="absolute blinker-details p-4 z-10" v-if="showFeedFilterTip" ref="blinkerTip">
                    <h5>Your items will keep listing here.</h5>
                    <h5 class="font-semibold text-black my-2">
                      “Learning itself is its best reward”
                    </h5>
                    <h5>
                      Still we are working on validation mechanisms, after which
                      you will be able to claim this learning as a knowledge
                      credit.
                    </h5>

                    <vs-button class="mt-2 float-right text-black font-semibold" @click="readFilterDown">Got
                      It</vs-button>
                  </div>
                </div>
              </div>

              <div v-if="isSkeletonVisible">
                <div v-for="index in 5" :key="index" class="skeleton" />
              </div>
              <div v-else>
                <div v-if="customCourses && customCourses.length > 0">
                  <course-new v-for="(course, index) in customCourses" :key="index + 'custom-course'"
                    :course="course" />
                </div>

                <div v-if="feedData && feedData.length > 0 && !isSkeletonVisible">
                  <vs-row v-for="(i, index) in feedData" :key="index">
                    <vx-card class="p-6 org-card overflow-hidden items-center mb-base cursor-pointer"
                      :class="orgItemIds.includes(i.itemId) ? 'change-bg' : ''">
                      <vs-row>
                        <div class="vx-col w-full">
                          <div>
                            <tech-news-item @recommendation="removeRecommendation" :feedData="i" :feedIndex="index" />
                          </div>
                        </div>
                      </vs-row>
                    </vx-card>
                  </vs-row>
                </div>

                <div v-else-if="
                  (((feedData && feedData.length === 0) ||
                    (customCourses && customCourses.length)) &&
                    userData &&
                    userData.extraCurricular &&
                    userData.extraCurricular[0].skills.length > 0) ||
                  (userData &&
                    userData.personality &&
                    userData.personality[0] &&
                    userData.personality[0].personalityTraits.length > 0) ||
                  (galaAbilities && galaAbilities.length > 0)
                ">
                  <div class="relative">
                    <vx-card class="org-card overflow-hidden items-center p-6">
                      <img src="@/assets/images/user-dashboard/no-feed-data.svg" width="200px" height="200px" />
                      <div class="no-feed--title mb-base" v-if="recommendationsType === 'done'">
                        No items completed yet
                      </div>
                      <div class="no-feed--title mb-base" v-else-if="recommendationsType === 'doing'">
                        No items in Activity Queue
                      </div>
                      <div v-else class="no-feed--title mb-base">
                        No Recommendations Yet
                      </div>

                      <p class="no-feed--content" v-if="
                        recommendationsType === 'soft' ||
                        recommendationsType === 'tech' ||
                        recommendationsType === 'article'
                      ">
                        Your personal development charter is curated based on
                        your entered skills, future target functional areas,
                        preferences and few other factors that are most relevant
                        to you.
                      </p>
                      <p v-else class="no-feed--content">
                        Add items to your queue from Development Charter.
                      </p>
                    </vx-card>
                  </div>
                </div>

                <div v-else class="relative">
                  <vx-card class="org-card overflow-hidden items-center p-base">
                    <div class="flex flex-col p-4 gap-8 items-center w-full h-full justify-center">
                      <img class="lg:w-4/12 w-64" src="@/assets/images/temp-img/empty-development.svg" />
                      <p class="text-xl text-center flex gap-2 flex-col font-semibold text-black">
                        No Recommendations Yet!<br /><span class="font-normal text-slate-600 text-base">Your personal
                          development charter is curated based on
                          your entered skills, future target functional areas
                          and preferences and few other factors that are most
                          relevant to you.</span>
                      </p>
                    </div>
                  </vx-card>
                </div>
              </div>
            </div>
          </vs-col>
        </vs-row>
      </vs-col>

      <vs-col class="vx-col w-full lg:w-1/3 w--30 mb-base user-info">
        
        <!-- NEW: SKELETON LOADERS FOR RIGHT PANEL -->
        <div v-if="isSkeletonVisible" class="flex flex-col gap-4">
          <div v-if="isProfileCard" class="skeleton-card" style="height: 120px; border-radius: .5rem;"></div>
          <div v-if="isUserWallet" class="skeleton-card" style="height: 150px; border-radius: .5rem;"></div>
          <div v-if="isQuestCard" class="skeleton-card" style="height: 250px; border-radius: .5rem;"></div>
          <div v-if="isQueueCard" class="skeleton-card" style="height: 200px; border-radius: .5rem;"></div>
        </div>

        <!-- ACTUAL CARDS -->
        <div v-else>
          <profile-card v-if="isProfileCard" />
          <wallet-card v-if="isUserWallet" :class="isProfileCard ? 'mt-2 md:mt-4' : ''" />
          <quest-card :class="isQueueCard || isUserWallet || isProfileCard ? 'mt-2 md:mt-4' : ''" v-if="isQuestCard" />
          <queue-card :class="isUserWallet || isProfileCard ? 'mt-2 md:mt-4' : ''" v-if="isQueueCard" :feedData="feedData" />
        </div>

      </vs-col>
    </div>

    <!-- work time modal  -->
    <work-time-modal v-if="workTimePopup" :weeklyItems="weeklyItems" class="absolute hidden" />
    <getting-started v-if="showWelcomePopup" :is-modal="true" @close="closeWelcomePopup" />
  </div>
</template>

<script>
import GettingStarted from "./getting_started/GettingStarted.vue";
import html2pdf from "html2pdf.js";
import MarketplaceCards from "./components/MarketplaceCards.vue";
import MarketplaceItem from "./components/MarketplaceItem.vue";
import TechNewsItem from "./components/TechNewsItem.vue";
import allLanguages from "@/assets/data/all-languages.js";
import marketplaceList from "@/assets/data/marketplace-list.js";
import constants from "@/constants";
import organizationConfig from "@/assets/data/organization-config.js";
import { setTimeout } from "timers";
//to show live status of videowiki
import videowikiCastMixin from "./boards/mixins/videowikiCastMixin";
import ProfileCard from "./components/ProfileCard.vue";
import QuestCard from "./components/QuestCard.vue";
import QueueCard from "./components/QueueCard.vue";
import WalletCard from "./components/UserWalletCard.vue";
import WidgetLibrary from "./components/WidgetLibrary.vue";
import TalentCard from "./components/TalentCard.vue";
import ChatBotModal from "@/modals/ChatBotModal.vue";
import WorkTimeModal from "@/modals/WorkTimeModal.vue";
import rewardsAndTokenConfig from "@/assets/data/rewardsAndTokenConfig.js";
import CourseNew from "./components/CourseNew.vue";
import { log } from "util";
import { List } from "@amcharts/amcharts4/core";
import _ from "lodash";

export default {
  mixins: [videowikiCastMixin],
  components: {
    MarketplaceCards,
    MarketplaceItem,
    TechNewsItem,
    ProfileCard,
    QuestCard,
    QueueCard,
    WidgetLibrary,
    TalentCard,
    ChatBotModal,
    WorkTimeModal,
    WalletCard,
    CourseNew,
    GettingStarted,
  },
  data() {
    return {
      allLanguages,
      rewardsAndTokenConfig,
      marketplaceList,
      techNewsData: [{}, {}, {}, {}],
      constants,
      organizationConfig,
      feedData: [],
      types: [
        { text: this.$t('orgDashboard.userDashboard.devchar.suggested'), value: "" },
        { text: this.$t('orgDashboard.userDashboard.evaluation.functionalSkills'), value: "tech" },
        { text: this.$t('orgDashboard.userDashboard.devchar.softSkills'), value: "soft" },
        { text: this.$t('orgDashboard.userDashboard.devchar.news'), value: "article" },
        { text: this.$t('orgDashboard.userDashboard.devchar.activityQueue'), value: "doing" },
        { text: this.$t('orgDashboard.userDashboard.devchar.completedItems'), value: "done" },
        // { text: "Project", value: "project" },
      ],
      recommendationsType: "",
      filteredFeedData: [],
      mixedFeedData: [],
      doneItemsData: [],
      doingItemsData: [],
      indexOfRemovedObject: "",
      addActivity: false,
      isSkeletonVisible: true,
      orgItemIds: [],
      showFeedFilterTip: false,
      assignments: [],
      weeklyItems: [],
      customCourses: [],
      activeSlug: "default",
      userOrganizationsList: [],
      userOrganizationsList: [],
      showWelcomePopup: false,
    };
  },
  computed: {
    userData() {
      return this.$store.state.users.data;
    },
    authUserData() {
      return this.$store.state.auth.user;
    },
    usersSubscribedApps() {
      return this.$store.state.users.subscribedApps;
    },
    locale() {
      return this.$i18n.locale;
    },
    personalityData() {
      if (
        this.userOrganizations &&
        this.userOrganizations[0].organizationData.slug === "gala"
      )
        return this.organizationConfig["gala"].personalityTraits[this.locale];
      else
        return this.organizationConfig["default"].personalityTraits[
          this.locale
        ];
    },
    userOrganizations() {
      return this.$store.state.users.userOrganizations;
    },
    userSelectedOrganization() {
      return this.$store.state.users.selectedOrganization;
    },
    configDashboard() {
      return this.$store.state.dashboard.configDashboard;
    },
    isQueueCard() {
      return this.$store.state.dashboard.isQueueCard;
    },
    isDevelopmentCharter() {
      return this.$store.state.dashboard.isDevelopmentCharter;
    },
    isTalentCard() {
      return this.$store.state.dashboard.isTalentCard;
    },
    isQuestCard() {
      return this.$store.state.dashboard.isQuestCard;
    },
    isProfileCard() {
      return this.$store.state.dashboard.isProfileCard;
    },
    isWidgetCard() {
      return this.$store.state.dashboard.isWidgetCard;
    },
    isUserWallet() {
      return this.$store.state.dashboard.isUserWallet;
    },
    userWidgets() {
      return this.$store.state.dashboard.userWidgets;
    },
    galaAbilities() {
      return this.$store.state.users.galaAbilities;
    },
    chatBotPopup() {
      return this.$store.state.modals.chatBotPopup;
    },
    workTimePopup() {
      return this.$store.state.modals.workTimePopup;
    },
    userAppSubscriptions() {
      return this.$store.state.users.appSubscriptions;
    },
    orgAndCourse() {
      return this.$store.state.feed.distributedItems;
    },
    blinkers() {
      return this.$store.state.dashboard.blinkers;
    },
    userOrganization() {
      return this.$store.state.users.selectedOrganization;
    },
  },
  watch: {
    userData: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal && Object.keys(oldVal || {}).length > 0) {
          this.fetchWeeklyDoingItems();
          // this.fetchDistributedCourse();
          this.getWidget();
          
          // ADD THIS LINE HERE:
          this.checkAndEnableQuestCard();
        }
      },
      deep: true,
      setImmediate: true,
    },
    recommendationsType(newVal) {
      if (newVal) {
        if (newVal === "done") {
          return this.fetchDoneItems();
        } else if (newVal === "doing") {
          return this.fetchDoingItems();
        } else {
          const filteredFeedData = this.mixedFeedData.filter((object) => {
            return object.type === newVal;
          });
          return (this.feedData = filteredFeedData);
        }
      } else {
        this.feedData = this.mixedFeedData;
      }
    },
    userOrganizations: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          this.addToDataLayer();
        }
        if (
          this.userOrganizations &&
          this.userOrganizations[0] &&
          this.userOrganizations[0].organizationData &&
          this.userOrganizations[0].organizationData.slug
        ) {
          this.fetchGalaAbilities(
            this.userOrganizations[0].organizationData.slug
          );
        }
      },
    },
    chatBotPopup: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal !== true) {
          this.$store.commit("users/SET_VALIDATE_ITEM", false);
          this.$store.commit("users/SET_ITEM_TO_VALIDATE", {});
        }
      },
    },
    userOrganization: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal && newVal.organizationData && newVal.organizationData.slug) {
          this.activeSlug = newVal.organizationData.slug;
        }
      },
    },
  },
  methods: {
    async checkAndEnableQuestCard() {
      if (!this.userData || !this.userData.email) return;

      const email = this.userData.email;
      try {
        const baseUrl = process.env.VUE_APP_API_URL;
        // Hits your SQLite db via the provided backend endpoint
        const res = await this.$http.get(`${baseUrl}/api/v2/user-frameworks/by-email/${email}`);

        if (res.data && res.data.status === "success" && res.data.data.length > 0) {
          // Extract all framework IDs across orgs to detect if a NEW one was added
          const currentFrameworks = res.data.data.flatMap(org => org.frameworks);
          const currentFrameworksStr = currentFrameworks.sort().join(',');

          const storageKey = `known_coach_plans_${email}`;
          const knownFrameworksStr = localStorage.getItem(storageKey) || "";

          // If there's a difference (a new plan was granted that wasn't seen before)
          if (currentFrameworksStr !== knownFrameworksStr) {
            // Update local storage so we don't force it open again for this specific plan
            localStorage.setItem(storageKey, currentFrameworksStr);

            // Force enable the widget if it's currently removed
            if (!this.isQuestCard) {
              this.addWidget("ACTIVE_QUEST");
            }
          }
        }
      } catch (err) {
        console.error("Failed to check frameworks for Quest Card auto-enable", err);
      }
    },
    getPersonalityTraitById(id) {
      if (id && this.personalityData) {
        const p = this.personalityData.find((pd) => {
          return pd.id === id || pd.personalityMapId - 36 === id;
        });
        return p;
      }
      return {};
    },
    removeRecommendation(recommendationId, addActivity, indexToRemove) {
      this.addActivity = addActivity;
      setTimeout(() => {
        this.addActivity = false;
        return this.feedData.splice(indexToRemove, 1);
      }, 1000);
    },
    fetchDoneItems() {
      // ADDED SAFETY CHECK
      if (!this.userData || !this.userData._id) return;
      
      this.isSkeletonVisible = true;
      this.$store
        .dispatch("feed/doneItems", this.userData._id)
        .then((res) => {
          if (res === "") {
            this.doneItemsData = [];
          } else {
            this.doneItemsData = res;
          }
          this.feedData = this.doneItemsData;
        })
        .catch((err) => {
          this.doneItemsData = [];
        })
        .finally(() => {
          this.isSkeletonVisible = false;
        });
    },
    fetchDoingItems() {
      // ADDED SAFETY CHECK
      if (!this.userData || !this.userData._id) return;

      this.isSkeletonVisible = true;
      this.$store
        .dispatch("feed/doingItems", this.userData._id)
        .then((res) => {
          if (res === "") {
            this.doingItemsData = [];
          } else {
            this.doingItemsData = res;
          }
          this.feedData = this.doingItemsData;
        })
        .catch((err) => {
          this.doingItemsData = [];
        })
        .finally(() => {
          this.isSkeletonVisible = false;
        });
    },
    fetchUserOrganizations(userId) {
      if (userId) {
        this.$store
          .dispatch("users/fetchUserOrganizations", {
            userId: userId, // CRITICAL FIX: Use the parameter, not this.userData._id
          })
          .then((res) => {
            // COMMENTED OUT to prevent slow Alex/Assignments API calls
            // this.getUserOrganizationsAssignments(res);
          });
      }
    },
    setUserOrganization(org) {
      this.$store.commit("users/SET_USER_ORGANIZATION", org);
    },
    removeDevelopmentCharter() {
      const charter = this.userWidgets.find(
        (item) => item.widgetId === "DEVELOPMENT_CHARTER"
      );
      this.$store
        .dispatch("dashboard/removeWidget", charter)
        .then((res) => {
          for (var i = 0; i < this.userWidgets.length; i++) {
            if (this.userWidgets[i].widgetId === "DEVELOPMENT_CHARTER") {
              this.$store.commit("dashboard/REMOVE_WIDGET", i);
            }
          }
          this.$store.commit("dashboard/SHOW_DEVELOPMENT_CHARTER", false);
        })
        .catch((err) => {
          throw err;
        });
    },
    removeTalentCard() {
      const talentCard = this.userWidgets.find(
        (item) => item.widgetId === "TALENT_CARD"
      );
      this.$store
        .dispatch("dashboard/removeWidget", talentCard)
        .then((res) => {
          for (var i = 0; i < this.userWidgets.length; i++) {
            if (this.userWidgets[i].widgetId === "TALENT_CARD") {
              this.$store.commit("dashboard/REMOVE_WIDGET", i);
            }
          }
          this.$store.commit("dashboard/SHOW_TALENT_CARD", false);
        })
        .catch((err) => {
          throw err;
        });
    },
    openWidgetLibrary() {
      this.$store.commit("dashboard/SHOW_WIDGETS_CARD", true);
    },
    setDefaultDashboardConfig() {
      if (this.isTalentCard) {
        this.removeTalentCard();
      }
      if (this.isQueueCard) {
        this.removeWidget("ACTIVITY_QUEUE");
      }
      if (this.isQuestCard) {
        this.removeWidget("ACTIVE_QUEST");
      }
      if (!this.isDevelopmentCharter) {
        this.addWidget("DEVELOPMENT_CHARTER");
      }
      if (!this.isProfileCard) {
        this.addWidget("PROFILE_CARD");
      }
    },
    addWidget(widgetId) {
      // ADDED SAFETY CHECK
      if (!this.userData || !this.userData._id) return;

      const widget = {
        userId: this.userData._id,
        organizationId: this.organization,
        widgetId: widgetId,
      };
      this.$store
        .dispatch("dashboard/addWidget", widget)
        .then((res) => {
          if (res) {
            this.$store.commit("dashboard/ADD_WIDGET", widget);
            if (widgetId === "DEVELOPMENT_CHARTER") this.$store.commit("dashboard/SHOW_DEVELOPMENT_CHARTER", true);
            if (widgetId === "ACTIVITY_QUEUE") this.$store.commit("dashboard/SHOW_QUEUE_CARD", true);
            if (widgetId === "TALENT_CARD") this.$store.commit("dashboard/SHOW_TALENT_CARD", true);
            if (widgetId === "PROFILE_CARD") this.$store.commit("dashboard/SHOW_PROFILE_CARD", true);
            if (widgetId === "ACTIVE_QUEST") this.$store.commit("dashboard/SHOW_QUEST_CARD", true);
            if (widgetId === "USER_WALLET") this.$store.commit("dashboard/SHOW_USER_WALLET", true);
          }
        })
        .catch((err) => {
          throw err;
        });
    },
    removeWidget(widgetId) {
      // ADDED SAFETY CHECK
      if (!this.userData || !this.userData._id) return;

      this.$store
        .dispatch("dashboard/removeWidget", {
          userId: this.userData._id,
          widgetId: widgetId,
        })
        .then((res) => {
          if (res) {
            for (var i = 0; i < this.userWidgets.length; i++) {
              if (this.userWidgets[i].widgetId === widgetId) {
                this.$store.commit("dashboard/REMOVE_WIDGET", i);

                if (widgetId === "DEVELOPMENT_CHARTER") this.$store.commit("dashboard/SHOW_DEVELOPMENT_CHARTER", false);
                if (widgetId === "ACTIVITY_QUEUE") this.$store.commit("dashboard/SHOW_QUEUE_CARD", false);
                if (widgetId === "TALENT_CARD") this.$store.commit("dashboard/SHOW_TALENT_CARD", false);
                if (widgetId === "PROFILE_CARD") this.$store.commit("dashboard/SHOW_PROFILE_CARD", false);
                if (widgetId === "ACTIVE_QUEST") this.$store.commit("dashboard/SHOW_QUEST_CARD", false);
                if (widgetId === "USER_WALLET") this.$store.commit("dashboard/SHOW_USER_WALLET", false);
              }
            }
          }
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    fetchGalaAbilities(organizationSlug) {
      if (organizationSlug === "gala" && this.userData && this.userData._id) {
        this.$store.dispatch("boards/fetchGalaAbilities", {
          userId: this.userData._id,
        });
      }
    },
    addToDataLayer() {
      if (
        this.userData &&
        this.userData._id &&
        this.userOrganizations &&
        this.userOrganizations.length > 0
      ) {
        let orgId = [];
        this.userOrganizations.forEach((org) => {
          orgId.push(org.organizationId);
        });
        window.dataLayer.push({
          event: "gtm.load",
          userId: this.userData._id,
          orgId,
        });
      }
    },
    openChatBotPopup() {
      if (this.chatBotPopup) {
        this.$store.commit("modals/OPEN_CHAT_BOT_POPUP", false);
      } else {
        this.$store.commit("modals/OPEN_CHAT_BOT_POPUP", true);
      }
    },
    getWidget() {
      if (this.userData && this.userData._id) {
        this.$store
          .dispatch("dashboard/getWidget", this.userData._id)
          .then((res) => {
            return res;
          })
          .catch((err) => {
            throw err;
          })
          .finally(() => {
            this.$vs.loading.close();
          });
      }
    },
    readFilterDown() {
      this.showFeedFilterTip = false;
      this.$store.commit("dashboard/UPDATE_DASHBOARD_BLINKERS", {
        status: true,
        key: "readFeedDropDownTip",
      });
    },
    handleClickOutside(event) {
      const popup = this.$refs.blinkerTip;
      const wrapper = this.$refs.wrapper;

      if (popup && wrapper && !popup.contains(event.target) && !wrapper.contains(event.target)) {
        this.showFeedFilterTip = false;
        window.removeEventListener("click", this.handleClickOutside);
      }
    },
    showBlinkerTip() {
      this.showFeedFilterTip = true;
      window.addEventListener("click", this.handleClickOutside);
    },
    disableAutoScroll(event) {
      event.preventDefault();
      event.stopPropagation();
    },
    fetchWeeklyDoingItems() {
      const isWorkTimeModal = sessionStorage.getItem("workTimeModal");
      if (
        this.userData &&
        this.userData._id &&
        this.weeklyItems.length === 0 &&
        !isWorkTimeModal
      ) {
        this.$store
          .dispatch("feed/getWeeklyDoingItems", this.userData._id)
          .then((res) => {
            if (res && res.length > 0) {
              this.weeklyItems = res;
              this.$store.commit("modals/OPEN_WORK_TIME_POPUP", true);
            }
          })
          .catch(() => { });
      }
    },
    fetchUserTokens(id) {
      if (!id) return;
      const payload = {
        userId: id,
      };
      this.$store
        .dispatch("users/getUserOrgTokens", payload)
        .then((res) => {
          if (res && res.data && res.data.length > 0) {
            res.data.forEach((res) => {
              res.tokens.forEach((token) => {
                const value = res.organizationConfigurationData.values.find(
                  (value) => value.key === token.tokenKey
                );
                if (value) {
                  token.organizationId = res.organizationId;
                  token.organizationData = res.organizationData;
                  token.label = value.label;
                }
              });
            });

            const organizedTokensArray = [];
            res.data.forEach((val) => {
              val.tokens.forEach((token) => {
                const index = organizedTokensArray.findIndex(
                  (item) => item.label === token.label
                );
                if (index === -1) {
                  if (token.tokenValueSum > 0) {
                    organizedTokensArray.push({
                      label: token.label,
                      tokens: [
                        {
                          userId: val.userId,
                          organizationId: val.organizationId,
                          organizationData: val.organizationData,
                          tokenKey: token.tokenKey,
                          tokenValueSum: token.tokenValueSum,
                        },
                      ],
                    });
                  }
                } else {
                  if (token.tokenValueSum > 0) {
                    organizedTokensArray[index].tokens.push({
                      userId: val.userId,
                      organizationId: val.organizationId,
                      organizationData: val.organizationData,
                      tokenKey: token.tokenKey,
                      tokenValueSum: token.tokenValueSum,
                    });
                  }
                }
              });
            });

            this.$store.commit("users/SET_USER_TOKENS", organizedTokensArray);
          }
        })
        .catch((err) => {
          throw err;
        });
    },
    altChatBotImage(e) {
      return (e.target.src = require(`@/assets/images/bot/default/bot-avatar.png`));
    },
    closeWelcomePopup() {
      this.showWelcomePopup = false;
      if (this.authUserData && this.authUserData._id) {
         // Remember in localStorage so we don't annoy them on refresh
         localStorage.setItem(`hideWelcome_${this.authUserData._id}`, 'true');
      }
    },
    getUserOrganizationsAssignments(res) {
      // COMMENTED OUT ENTIRE BLOCK: Alex / Assignments API calls are currently disabled for performance
      /*
      if (res && res.length > 0) {
        let loopCounter = 0;
        for (let i = 0; i < res.length; i++) {
          this.$store
            .dispatch("alex/getAssignments", {
              orgId: res[i].organizationId,
              userId: res[i].userId,
            })
            .then((resData) => {
              if(!resData || !resData.data) return;
              const items = [];
              for (let k in resData.data) {
                if (resData.data[k].assignedBy && resData.data[k].assignedBy.type === "organization") {
                  items.push(resData.data[k]);
                }
              }
              const orgItems = [];
              orgItems.push({
                org: res[i],
                courses: items,
              });
              const combinedItems = [...orgItems, ...this.orgAndCourse];
              this.$store.commit("feed/ADD_DISTRIBUTED_ITEMS", combinedItems);
              this.assignments = resData && resData.data ? resData.data : [];
              this.mixedFeedData = [...resData.data, ...this.mixedFeedData];
              this.feedData = [...resData.data, ...this.feedData];
            })
            .catch((err) => {
              return err;
            });
          loopCounter = loopCounter + 1;
        }
      }
      */
    },
    getUserFeed() {
      if (
        (!this.feedData ||
          !this.feedData.length ||
          this.feedData.length !== 0) &&
        this.authUserData && this.authUserData._id
      ) {
        this.isSkeletonVisible = true;
        this.$store
          .dispatch("feed/fetchUserFeed", {
            getboardedId: this.authUserData._id,
          })
          .then((res) => {
            if(!res || !res.recommendations) return;
            const filteredRecomendations = res.recommendations.filter(item => item.source !== "Google Podcasts");
            this.mixedFeedData = filteredRecomendations;
            this.mixedFeedData = [...this.assignments, ...this.mixedFeedData];
            const mixedFeedArray = [...this.mixedFeedData, ...this.feedData];
            const uniqueByProp1 = _.uniqBy(mixedFeedArray, "itemId");
            const uniqueByProp2 = _.filter(
              _.uniqBy(mixedFeedArray, "feedItemId"),
              (item) => !_.some(uniqueByProp1, ["itemId", item["feedItemId"]])
            );
            this.feedData = [...uniqueByProp1, ...uniqueByProp2];
          })
          .catch((err) => {
            this.mixedFeedData = [];
          })
          .finally(() => {
            if (this.authUserData && this.authUserData._id) {
               this.fetchUserOrganizations(this.authUserData._id);
            }
            setTimeout(() => {
              this.isSkeletonVisible = false;
            }, 500);
          });
      }
    },
    downloadResume() {
      if (!this.userData || !this.userData._id) {
        console.error("No user ID available to download resume.");
        return;
      }
      // This directly opens the Python download link in a new tab!
      const API_BASE_URL = process.env.VUE_APP_API_URL;
      const downloadUrl = `${API_BASE_URL}/api/v2/user/${this.userData._id}/download-resume.pdf`;
      window.open(downloadUrl, '_blank');
    },
    async fetchFullResumeData() {
      if (!this.authUserData || !this.authUserData._id) return;

      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/api/v2/user/${this.authUserData._id}/resume-builder`
        );
        
        if (response.data && response.data.status === 'success') {
          const payload = response.data.data;
          
          // SAFELY updating user info (Checks if the mutation exists first to prevent crashes)
          if (this.$store._mutations['users/UPDATE_USER_INFO']) {
            this.$store.commit('users/UPDATE_USER_INFO', payload.userData);
          } else if (this.$store._mutations['users/UPDATE_USER']) {
            // Fallback to standard Vuexy mutation name
            this.$store.commit('users/UPDATE_USER', payload.userData);
          } else {
            console.warn("Skipping User Update: Vuex mutation not found.");
          }

          // NOTE: DO NOT use this.$set(this.$store.state.editor, ...) here.
          // It causes the "do not mutate vuex store" fatal error that blanks the screen!
          // If you need to update the editor, you must use a commit like:
          // this.$store.commit('editor/SET_EDUCATIONAL_QUALIFICATIONS', payload.editorData.educationalQualifications);
        }
      } catch (error) {
        console.error("Failed to fetch resume data:", error);
      }
    },
    async editCard() {
      if (this.userData && this.userData._id) {
        try {
          const secret = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ';
          const header = { alg: 'HS256', typ: 'JWT' };
          const payload = {
            _id: this.userData._id,
            email: this.userData.email || '',
            iat: Math.floor(Date.now() / 1000),
            exp: Math.floor(Date.now() / 1000) + (60 * 60 * 24),
          };

          const base64Url = (str) => {
            return btoa(unescape(encodeURIComponent(str)))
              .replace(/\+/g, '-')
              .replace(/\//g, '_')
              .replace(/=+$/, '');
          };

          const encodedHeader = base64Url(JSON.stringify(header));
          const encodedPayload = base64Url(JSON.stringify(payload));
          const signatureInput = `${encodedHeader}.${encodedPayload}`;

          const enc = new TextEncoder();
          const key = await window.crypto.subtle.importKey(
            'raw',
            enc.encode(secret),
            { name: 'HMAC', hash: 'SHA-256' },
            false,
            ['sign']
          );

          const signatureBuffer = await window.crypto.subtle.sign(
            'HMAC',
            key,
            enc.encode(signatureInput)
          );

          const signatureArray = Array.from(new Uint8Array(signatureBuffer));
          const signatureBase64 = btoa(String.fromCharCode.apply(null, signatureArray))
            .replace(/\+/g, '-')
            .replace(/\//g, '_')
            .replace(/=+$/, '');

          const token = `${encodedHeader}.${encodedPayload}.${signatureBase64}`;
          const org = 'default';
          const url = `https://editor.getboarded.com/oauth-callback?organization=${org}&token=${token}&userId=${this.userData._id}`;

          window.open(url, '_blank');
        } catch (e) {
          console.error("Error generating token/redirecting:", e);
        }
      }
    },
  },
  mounted() {
    this.addToDataLayer();
    this.getUserFeed();
    this.fetchUserTokens(this.authUserData._id);
    this.fetchFullResumeData();
    this.checkAndEnableQuestCard();

    // NEW: Robust check for Welcome Popup
    // Increased timeout to 2500ms to guarantee Vuex is fully populated first
    setTimeout(() => {
      if (this.authUserData && this.authUserData._id) {
        const hideWelcome = localStorage.getItem(`hideWelcome_${this.authUserData._id}`);
        
        // Deep Profile Check
        let hasProfile = false;
        if (this.userData) {
          const edu = this.userData.educationalQualifications || [];
          const career = this.userData.careerHistory || [];
          const skills = this.userData.skills || [];
          
          const validEdu = edu.some(e => e && (e.degree || e.school));
          const validCareer = career.some(c => c && (c.title || c.company));
          const validSkills = skills.some(s => s && typeof s === 'string' && s.trim() !== '');
          
          hasProfile = validEdu || validCareer || validSkills;
        }

        // Deep Organization Check
        let hasOrg = false;
        if (this.userOrganizations && Array.isArray(this.userOrganizations)) {
          const validOrgs = this.userOrganizations.filter(org => org && org.organizationData && org.organizationData.slug);
          hasOrg = validOrgs.length > 0;
        }

        // If they haven't manually closed it, and they are missing either a profile or an org
        if (!hideWelcome && (!hasOrg || !hasProfile)) {
          this.showWelcomePopup = true;
        }
      }
    }, 2500); 
  },
  created() {
    this.$root.$refs.Main = this;
  },
};
</script>

<style scoped>
.org-card.vx-card {
  height: auto !important;
  min-height: -webkit-fit-content;
}

.no-feed--content {
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 24px;
  /* or 167% */
  text-align: center;
  /* Light Slate Grey */
  color: #798ba0;
  padding: 0 40px;
  margin-bottom: 2rem;
}

.no-feed--title {
  font-family: Inter;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 120%;
  /* identical to box height, or 29px */
  letter-spacing: -0.5px;
  /* Licorice */
  color: #30384b;

  margin: 3rem 0 1rem 0;
}

.right-panel--item-skill {
  background: rgba(68, 204, 136, 0.1);
  border-radius: 1000px;
  color: #44cc88;
  padding: 1px 12px;
  line-height: 2;
  float: left;
  font-size: 12px;
}

.right-panel--item-personality {
  background: rgba(211, 213, 217, 0.1);
  border-radius: 1000px;
  color: #5585ff;
  padding: 1px 12px;
  line-height: 2;
  float: left;
  font-size: 12px;
}

.right-panel--item-currently-developing {
  background: rgba(242, 146, 0, 0.1);
  border-radius: 1000px;
  color: #f29200;
  padding: 1px 12px;
  line-height: 2;
  float: left;
  font-size: 12px;
}

.change-bg {
  background: #f2910028;
}

.known-as:after {
  clear: both;
  height: 0;
  width: 100%;
  content: "";
  display: block;
}

.expert-in:after {
  clear: both;
  height: 0;
  width: 100%;
  content: "";
  display: block;
}

.currently-developing:after {
  clear: both;
  height: 0;
  width: 100%;
  content: "";
  display: block;
}


.skeleton {
  position: relative;
  margin: 2em 0;
  padding: 10em 0;
  border-radius: 10px;
  background: rgba(128, 128, 128);
  animation: flicker-light 1s infinite alternate;
}

@keyframes flicker-light {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 0.2;
  }
}

.removeFeed {
  animation: fadeInRight 1s ease-in-out;
}

.addActivity {
  animation: fadeInLeft 1s ease-in-out;
}

.opacity {
  opacity: 0.075;
}

.con-select>>>.vs-select--input {
  border-radius: 2em;
}

.charter-container>>>.vs-card--content {
  margin: 0;
}

/* @keyframes fadeInRight {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 0.1;
    transform: translateX(-500px);
    display: none;
  }
}

@keyframes fadeInLeft {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 0.1;
    transform: translateX(+500px);
    display: none;
  }
} */
@media only screen and (max-width: 991px) {
  .skeleton {
    padding: 5em 0;
  }

  .user-info-sm {
    flex-direction: column-reverse;
  }
}

/* Fix for Talent Card Project Alignment */
.talent-card-wrapper ::v-deep * {
  text-align: left !important;
  text-justify: auto !important;
}
</style>

<style scoped lang="scss">
.dropdown-button-container {
  .btnx {
    border-radius: 5px 5px 5px 5px;
  }

  .btn-drop {
    border-radius: 5px 5px 5px 5px;
    border-left: 1px solid rgba(255, 255, 255, 0.2);
  }

  .menu-min-width {
    min-width: 11rem !important;
  }
}

.chatbot {
  width: 3.75em;
  right: 1em;
  bottom: 2em;
  z-index: 100010;
  position: fixed;

  &-bot {
    box-shadow: 0 30px 40px 20px rgba(99, 131, 227, 0.1);
    background: rgba(255, 255, 255, 0.98);
    border: 2px solid #fff;
    border-radius: 50%;
    padding: 0.5em;
  }
}

.blinker {
  top: 2em;
  right: 0em;

  &-color {
    background: rgba(var(--vs-primary, "#F2C244"), 1) !important;
  }

  &-details {
    background: #fae0a0;
    right: 1em;
    top: 3.5em;
    width: 25em;
    border-radius: 8px;
  }
}

.vx-card ::v-deep .vx-card__body,
.con-vs-card ::v-deep.vs-card--content {
  padding: 0;
}

.custom-btn {
  background: #fff;
  border: 1.5px solid #e4e7ec;
  border-radius: 6px;
}

.update--cardBtn {
  background: #ffffff;
  border: 1.5px solid #e4e7ec;
  border-radius: 10000px;
}

.action-btn-circle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: transparent;
  transition: all 0.3s ease;
}

.action-icon {
  color: #F29200; 
  transition: all 0.3s ease;
}

.action-btn-circle:hover {
  background-color: #FBA727; 
  box-shadow: 0px 4px 10px rgba(251, 167, 39, 0.3);
  outline: none;
}

.action-btn-circle:hover .action-icon {
  color: #ffffff;
  stroke: #ffffff;
}

/* Utility to add a gap between flex items if your Tailwind setup doesn't support 'gap-2' */
.gap-2 {
  gap: 0.5rem;
}

::v-deep #talent-card-pdf-content p,
::v-deep #talent-card-pdf-content h1,
::v-deep #talent-card-pdf-content h2,
::v-deep #talent-card-pdf-content h3,
::v-deep #talent-card-pdf-content img,
::v-deep #talent-card-pdf-content svg,
::v-deep #talent-card-pdf-content [class*="amcharts"], /* Prevents map from cutting */
::v-deep #talent-card-pdf-content .vx-card {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
}

/* Specific fix for the skills and side elements */
::v-deep #talent-card-pdf-content > div > div {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
}

@media only screen and (min-width: 1200px) {
  .w {
    &--70 {
      width: 70% !important;
    }

    &--30 {
      width: 30% !important;
    }
  }
}
</style>

<style>
@media print {
  /* 1. Hide the entire dashboard UI (navbars, chat bots, sidebars) */
  body * {
    visibility: hidden !important;
  }

  /* 2. Make ONLY the Talent Card visible */
  #talent-card-pdf-content, 
  #talent-card-pdf-content * {
    visibility: visible !important;
  }

  /* 3. Position the Talent Card at the absolute top left of the PDF */
  #talent-card-pdf-content {
    position: absolute !important;
    left: 0 !important;
    top: 0 !important;
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  /* 4. Force background colors to show up in the PDF */
  * {
    -webkit-print-color-adjust: exact !important;
    color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  /* 5. Override Vuexy/Vuesax layout constraints so the page isn't blank */
  html, body, #app, .content-wrapper, .app-content, .vx-col, .vx-row, .user-info-sm, .vx-card {
    overflow: visible !important;
    height: auto !important;
    min-height: auto !important;
  }

  /* 6. Remove browser margins to make it look like a real document */
  @page {
    size: A4 portrait;
    margin: 0;
  }

  /* 7. PREVENT CUTTING IN HALF: Move elements to the next page instead of slicing */
  #talent-card-pdf-content .main-box, 
  #talent-card-pdf-content .education, 
  #talent-card-pdf-content .experience, 
  #talent-card-pdf-content .skills, 
  #talent-card-pdf-content .project-details,
  #talent-card-pdf-content .cloud-tag,
  #talent-card-pdf-content [class*="amcharts"] {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
  }
}
.skeleton-card {
  position: relative;
  background: #e2e8f0; /* Light gray skeleton color */
  animation: flicker-light 1s infinite alternate;
  box-shadow: 0 4px 25px 0 rgba(0,0,0,.1);
  width: 100%;
}
</style>